// jquery validation plugin code start here

/*! jQuery Validation Plugin - v1.19.5 - 7/1/2022
 * https://jqueryvalidation.org/
 * Copyright (c) 2022 Jörn Zaefferer; Licensed MIT */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof module&&module.exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){a.extend(a.fn,{validate:function(b){if(!this.length)return void(b&&b.debug&&window.console&&console.warn("Nothing selected, can't validate, returning nothing."));var c=a.data(this[0],"validator");return c?c:(this.attr("novalidate","novalidate"),c=new a.validator(b,this[0]),a.data(this[0],"validator",c),c.settings.onsubmit&&(this.on("click.validate",":submit",function(b){c.submitButton=b.currentTarget,a(this).hasClass("cancel")&&(c.cancelSubmit=!0),void 0!==a(this).attr("formnovalidate")&&(c.cancelSubmit=!0)}),this.on("submit.validate",function(b){function d(){var d,e;return c.submitButton&&(c.settings.submitHandler||c.formSubmitted)&&(d=a("<input type='hidden'/>").attr("name",c.submitButton.name).val(a(c.submitButton).val()).appendTo(c.currentForm)),!(c.settings.submitHandler&&!c.settings.debug)||(e=c.settings.submitHandler.call(c,c.currentForm,b),d&&d.remove(),void 0!==e&&e)}return c.settings.debug&&b.preventDefault(),c.cancelSubmit?(c.cancelSubmit=!1,d()):c.form()?c.pendingRequest?(c.formSubmitted=!0,!1):d():(c.focusInvalid(),!1)})),c)},valid:function(){var b,c,d;return a(this[0]).is("form")?b=this.validate().form():(d=[],b=!0,c=a(this[0].form).validate(),this.each(function(){b=c.element(this)&&b,b||(d=d.concat(c.errorList))}),c.errorList=d),b},rules:function(b,c){var d,e,f,g,h,i,j=this[0],k="undefined"!=typeof this.attr("contenteditable")&&"false"!==this.attr("contenteditable");if(null!=j&&(!j.form&&k&&(j.form=this.closest("form")[0],j.name=this.attr("name")),null!=j.form)){if(b)switch(d=a.data(j.form,"validator").settings,e=d.rules,f=a.validator.staticRules(j),b){case"add":a.extend(f,a.validator.normalizeRule(c)),delete f.messages,e[j.name]=f,c.messages&&(d.messages[j.name]=a.extend(d.messages[j.name],c.messages));break;case"remove":return c?(i={},a.each(c.split(/\s/),function(a,b){i[b]=f[b],delete f[b]}),i):(delete e[j.name],f)}return g=a.validator.normalizeRules(a.extend({},a.validator.classRules(j),a.validator.attributeRules(j),a.validator.dataRules(j),a.validator.staticRules(j)),j),g.required&&(h=g.required,delete g.required,g=a.extend({required:h},g)),g.remote&&(h=g.remote,delete g.remote,g=a.extend(g,{remote:h})),g}}});var b=function(a){return a.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")};a.extend(a.expr.pseudos||a.expr[":"],{blank:function(c){return!b(""+a(c).val())},filled:function(c){var d=a(c).val();return null!==d&&!!b(""+d)},unchecked:function(b){return!a(b).prop("checked")}}),a.validator=function(b,c){this.settings=a.extend(!0,{},a.validator.defaults,b),this.currentForm=c,this.init()},a.validator.format=function(b,c){return 1===arguments.length?function(){var c=a.makeArray(arguments);return c.unshift(b),a.validator.format.apply(this,c)}:void 0===c?b:(arguments.length>2&&c.constructor!==Array&&(c=a.makeArray(arguments).slice(1)),c.constructor!==Array&&(c=[c]),a.each(c,function(a,c){b=b.replace(new RegExp("\\{"+a+"\\}","g"),function(){return c})}),b)},a.extend(a.validator,{defaults:{messages:{},groups:{},rules:{},errorClass:"error",pendingClass:"pending",validClass:"valid",errorElement:"label",focusCleanup:!1,focusInvalid:!0,errorContainer:a([]),errorLabelContainer:a([]),onsubmit:!0,ignore:":hidden",ignoreTitle:!1,onfocusin:function(a){this.lastActive=a,this.settings.focusCleanup&&(this.settings.unhighlight&&this.settings.unhighlight.call(this,a,this.settings.errorClass,this.settings.validClass),this.hideThese(this.errorsFor(a)))},onfocusout:function(a){this.checkable(a)||!(a.name in this.submitted)&&this.optional(a)||this.element(a)},onkeyup:function(b,c){var d=[16,17,18,20,35,36,37,38,39,40,45,144,225];9===c.which&&""===this.elementValue(b)||a.inArray(c.keyCode,d)!==-1||(b.name in this.submitted||b.name in this.invalid)&&this.element(b)},onclick:function(a){a.name in this.submitted?this.element(a):a.parentNode.name in this.submitted&&this.element(a.parentNode)},highlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).addClass(c).removeClass(d):a(b).addClass(c).removeClass(d)},unhighlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).removeClass(c).addClass(d):a(b).removeClass(c).addClass(d)}},setDefaults:function(b){a.extend(a.validator.defaults,b)},messages:{required:"This field is required.",remote:"Please fix this field.",email:"Please enter a valid email address.",url:"Please enter a valid URL.",date:"Please enter a valid date.",dateISO:"Please enter a valid date (ISO).",number:"Please enter a valid number.",digits:"Please enter only digits.",equalTo:"Please enter the same value again.",maxlength:a.validator.format("Please enter no more than {0} characters."),minlength:a.validator.format("Please enter at least {0} characters."),rangelength:a.validator.format("Please enter a value between {0} and {1} characters long."),range:a.validator.format("Please enter a value between {0} and {1}."),max:a.validator.format("Please enter a value less than or equal to {0}."),min:a.validator.format("Please enter a value greater than or equal to {0}."),step:a.validator.format("Please enter a multiple of {0}.")},autoCreateRanges:!1,prototype:{init:function(){function b(b){var c="undefined"!=typeof a(this).attr("contenteditable")&&"false"!==a(this).attr("contenteditable");if(!this.form&&c&&(this.form=a(this).closest("form")[0],this.name=a(this).attr("name")),d===this.form){var e=a.data(this.form,"validator"),f="on"+b.type.replace(/^validate/,""),g=e.settings;g[f]&&!a(this).is(g.ignore)&&g[f].call(e,this,b)}}this.labelContainer=a(this.settings.errorLabelContainer),this.errorContext=this.labelContainer.length&&this.labelContainer||a(this.currentForm),this.containers=a(this.settings.errorContainer).add(this.settings.errorLabelContainer),this.submitted={},this.valueCache={},this.pendingRequest=0,this.pending={},this.invalid={},this.reset();var c,d=this.currentForm,e=this.groups={};a.each(this.settings.groups,function(b,c){"string"==typeof c&&(c=c.split(/\s/)),a.each(c,function(a,c){e[c]=b})}),c=this.settings.rules,a.each(c,function(b,d){c[b]=a.validator.normalizeRule(d)}),a(this.currentForm).on("focusin.validate focusout.validate keyup.validate",":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']",b).on("click.validate","select, option, [type='radio'], [type='checkbox']",b),this.settings.invalidHandler&&a(this.currentForm).on("invalid-form.validate",this.settings.invalidHandler)},form:function(){return this.checkForm(),a.extend(this.submitted,this.errorMap),this.invalid=a.extend({},this.errorMap),this.valid()||a(this.currentForm).triggerHandler("invalid-form",[this]),this.showErrors(),this.valid()},checkForm:function(){this.prepareForm();for(var a=0,b=this.currentElements=this.elements();b[a];a++)this.check(b[a]);return this.valid()},element:function(b){var c,d,e=this.clean(b),f=this.validationTargetFor(e),g=this,h=!0;return void 0===f?delete this.invalid[e.name]:(this.prepareElement(f),this.currentElements=a(f),d=this.groups[f.name],d&&a.each(this.groups,function(a,b){b===d&&a!==f.name&&(e=g.validationTargetFor(g.clean(g.findByName(a))),e&&e.name in g.invalid&&(g.currentElements.push(e),h=g.check(e)&&h))}),c=this.check(f)!==!1,h=h&&c,c?this.invalid[f.name]=!1:this.invalid[f.name]=!0,this.numberOfInvalids()||(this.toHide=this.toHide.add(this.containers)),this.showErrors(),a(b).attr("aria-invalid",!c)),h},showErrors:function(b){if(b){var c=this;a.extend(this.errorMap,b),this.errorList=a.map(this.errorMap,function(a,b){return{message:a,element:c.findByName(b)[0]}}),this.successList=a.grep(this.successList,function(a){return!(a.name in b)})}this.settings.showErrors?this.settings.showErrors.call(this,this.errorMap,this.errorList):this.defaultShowErrors()},resetForm:function(){a.fn.resetForm&&a(this.currentForm).resetForm(),this.invalid={},this.submitted={},this.prepareForm(),this.hideErrors();var b=this.elements().removeData("previousValue").removeAttr("aria-invalid");this.resetElements(b)},resetElements:function(a){var b;if(this.settings.unhighlight)for(b=0;a[b];b++)this.settings.unhighlight.call(this,a[b],this.settings.errorClass,""),this.findByName(a[b].name).removeClass(this.settings.validClass);else a.removeClass(this.settings.errorClass).removeClass(this.settings.validClass)},numberOfInvalids:function(){return this.objectLength(this.invalid)},objectLength:function(a){var b,c=0;for(b in a)void 0!==a[b]&&null!==a[b]&&a[b]!==!1&&c++;return c},hideErrors:function(){this.hideThese(this.toHide)},hideThese:function(a){a.not(this.containers).text(""),this.addWrapper(a).hide()},valid:function(){return 0===this.size()},size:function(){return this.errorList.length},focusInvalid:function(){if(this.settings.focusInvalid)try{a(this.findLastActive()||this.errorList.length&&this.errorList[0].element||[]).filter(":visible").trigger("focus").trigger("focusin")}catch(b){}},findLastActive:function(){var b=this.lastActive;return b&&1===a.grep(this.errorList,function(a){return a.element.name===b.name}).length&&b},elements:function(){var b=this,c={};return a(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function(){var d=this.name||a(this).attr("name"),e="undefined"!=typeof a(this).attr("contenteditable")&&"false"!==a(this).attr("contenteditable");return!d&&b.settings.debug&&window.console&&console.error("%o has no name assigned",this),e&&(this.form=a(this).closest("form")[0],this.name=d),this.form===b.currentForm&&(!(d in c||!b.objectLength(a(this).rules()))&&(c[d]=!0,!0))})},clean:function(b){return a(b)[0]},errors:function(){var b=this.settings.errorClass.split(" ").join(".");return a(this.settings.errorElement+"."+b,this.errorContext)},resetInternals:function(){this.successList=[],this.errorList=[],this.errorMap={},this.toShow=a([]),this.toHide=a([])},reset:function(){this.resetInternals(),this.currentElements=a([])},prepareForm:function(){this.reset(),this.toHide=this.errors().add(this.containers)},prepareElement:function(a){this.reset(),this.toHide=this.errorsFor(a)},elementValue:function(b){var c,d,e=a(b),f=b.type,g="undefined"!=typeof e.attr("contenteditable")&&"false"!==e.attr("contenteditable");return"radio"===f||"checkbox"===f?this.findByName(b.name).filter(":checked").val():"number"===f&&"undefined"!=typeof b.validity?b.validity.badInput?"NaN":e.val():(c=g?e.text():e.val(),"file"===f?"C:\\fakepath\\"===c.substr(0,12)?c.substr(12):(d=c.lastIndexOf("/"),d>=0?c.substr(d+1):(d=c.lastIndexOf("\\"),d>=0?c.substr(d+1):c)):"string"==typeof c?c.replace(/\r/g,""):c)},check:function(b){b=this.validationTargetFor(this.clean(b));var c,d,e,f,g=a(b).rules(),h=a.map(g,function(a,b){return b}).length,i=!1,j=this.elementValue(b);"function"==typeof g.normalizer?f=g.normalizer:"function"==typeof this.settings.normalizer&&(f=this.settings.normalizer),f&&(j=f.call(b,j),delete g.normalizer);for(d in g){e={method:d,parameters:g[d]};try{if(c=a.validator.methods[d].call(this,j,b,e.parameters),"dependency-mismatch"===c&&1===h){i=!0;continue}if(i=!1,"pending"===c)return void(this.toHide=this.toHide.not(this.errorsFor(b)));if(!c)return this.formatAndAdd(b,e),!1}catch(k){throw this.settings.debug&&window.console&&console.log("Exception occurred when checking element "+b.id+", check the '"+e.method+"' method.",k),k instanceof TypeError&&(k.message+=".  Exception occurred when checking element "+b.id+", check the '"+e.method+"' method."),k}}if(!i)return this.objectLength(g)&&this.successList.push(b),!0},customDataMessage:function(b,c){return a(b).data("msg"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase())||a(b).data("msg")},customMessage:function(a,b){var c=this.settings.messages[a];return c&&(c.constructor===String?c:c[b])},findDefined:function(){for(var a=0;a<arguments.length;a++)if(void 0!==arguments[a])return arguments[a]},defaultMessage:function(b,c){"string"==typeof c&&(c={method:c});var d=this.findDefined(this.customMessage(b.name,c.method),this.customDataMessage(b,c.method),!this.settings.ignoreTitle&&b.title||void 0,a.validator.messages[c.method],"<strong>Warning: No message defined for "+b.name+"</strong>"),e=/\$?\{(\d+)\}/g;return"function"==typeof d?d=d.call(this,c.parameters,b):e.test(d)&&(d=a.validator.format(d.replace(e,"{$1}"),c.parameters)),d},formatAndAdd:function(a,b){var c=this.defaultMessage(a,b);this.errorList.push({message:c,element:a,method:b.method}),this.errorMap[a.name]=c,this.submitted[a.name]=c},addWrapper:function(a){return this.settings.wrapper&&(a=a.add(a.parent(this.settings.wrapper))),a},defaultShowErrors:function(){var a,b,c;for(a=0;this.errorList[a];a++)c=this.errorList[a],this.settings.highlight&&this.settings.highlight.call(this,c.element,this.settings.errorClass,this.settings.validClass),this.showLabel(c.element,c.message);if(this.errorList.length&&(this.toShow=this.toShow.add(this.containers)),this.settings.success)for(a=0;this.successList[a];a++)this.showLabel(this.successList[a]);if(this.settings.unhighlight)for(a=0,b=this.validElements();b[a];a++)this.settings.unhighlight.call(this,b[a],this.settings.errorClass,this.settings.validClass);this.toHide=this.toHide.not(this.toShow),this.hideErrors(),this.addWrapper(this.toShow).show()},validElements:function(){return this.currentElements.not(this.invalidElements())},invalidElements:function(){return a(this.errorList).map(function(){return this.element})},showLabel:function(b,c){var d,e,f,g,h=this.errorsFor(b),i=this.idOrName(b),j=a(b).attr("aria-describedby");h.length?(h.removeClass(this.settings.validClass).addClass(this.settings.errorClass),h.html(c)):(h=a("<"+this.settings.errorElement+">").attr("id",i+"-error").addClass(this.settings.errorClass).html(c||""),d=h,this.settings.wrapper&&(d=h.hide().show().wrap("<"+this.settings.wrapper+"/>").parent()),this.labelContainer.length?this.labelContainer.append(d):this.settings.errorPlacement?this.settings.errorPlacement.call(this,d,a(b)):d.insertAfter(b),h.is("label")?h.attr("for",i):0===h.parents("label[for='"+this.escapeCssMeta(i)+"']").length&&(f=h.attr("id"),j?j.match(new RegExp("\\b"+this.escapeCssMeta(f)+"\\b"))||(j+=" "+f):j=f,a(b).attr("aria-describedby",j),e=this.groups[b.name],e&&(g=this,a.each(g.groups,function(b,c){c===e&&a("[name='"+g.escapeCssMeta(b)+"']",g.currentForm).attr("aria-describedby",h.attr("id"))})))),!c&&this.settings.success&&(h.text(""),"string"==typeof this.settings.success?h.addClass(this.settings.success):this.settings.success(h,b)),this.toShow=this.toShow.add(h)},errorsFor:function(b){var c=this.escapeCssMeta(this.idOrName(b)),d=a(b).attr("aria-describedby"),e="label[for='"+c+"'], label[for='"+c+"'] *";return d&&(e=e+", #"+this.escapeCssMeta(d).replace(/\s+/g,", #")),this.errors().filter(e)},escapeCssMeta:function(a){return void 0===a?"":a.replace(/([\\!"#$%&'()*+,./:;<=>?@\[\]^`{|}~])/g,"\\$1")},idOrName:function(a){return this.groups[a.name]||(this.checkable(a)?a.name:a.id||a.name)},validationTargetFor:function(b){return this.checkable(b)&&(b=this.findByName(b.name)),a(b).not(this.settings.ignore)[0]},checkable:function(a){return/radio|checkbox/i.test(a.type)},findByName:function(b){return a(this.currentForm).find("[name='"+this.escapeCssMeta(b)+"']")},getLength:function(b,c){switch(c.nodeName.toLowerCase()){case"select":return a("option:selected",c).length;case"input":if(this.checkable(c))return this.findByName(c.name).filter(":checked").length}return b.length},depend:function(a,b){return!this.dependTypes[typeof a]||this.dependTypes[typeof a](a,b)},dependTypes:{"boolean":function(a){return a},string:function(b,c){return!!a(b,c.form).length},"function":function(a,b){return a(b)}},optional:function(b){var c=this.elementValue(b);return!a.validator.methods.required.call(this,c,b)&&"dependency-mismatch"},startRequest:function(b){this.pending[b.name]||(this.pendingRequest++,a(b).addClass(this.settings.pendingClass),this.pending[b.name]=!0)},stopRequest:function(b,c){this.pendingRequest--,this.pendingRequest<0&&(this.pendingRequest=0),delete this.pending[b.name],a(b).removeClass(this.settings.pendingClass),c&&0===this.pendingRequest&&this.formSubmitted&&this.form()&&0===this.pendingRequest?(a(this.currentForm).trigger("submit"),this.submitButton&&a("input:hidden[name='"+this.submitButton.name+"']",this.currentForm).remove(),this.formSubmitted=!1):!c&&0===this.pendingRequest&&this.formSubmitted&&(a(this.currentForm).triggerHandler("invalid-form",[this]),this.formSubmitted=!1)},previousValue:function(b,c){return c="string"==typeof c&&c||"remote",a.data(b,"previousValue")||a.data(b,"previousValue",{old:null,valid:!0,message:this.defaultMessage(b,{method:c})})},destroy:function(){this.resetForm(),a(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur").find(".validate-lessThan-blur").off(".validate-lessThan").removeClass("validate-lessThan-blur").find(".validate-lessThanEqual-blur").off(".validate-lessThanEqual").removeClass("validate-lessThanEqual-blur").find(".validate-greaterThanEqual-blur").off(".validate-greaterThanEqual").removeClass("validate-greaterThanEqual-blur").find(".validate-greaterThan-blur").off(".validate-greaterThan").removeClass("validate-greaterThan-blur")}},classRuleSettings:{required:{required:!0},email:{email:!0},url:{url:!0},date:{date:!0},dateISO:{dateISO:!0},number:{number:!0},digits:{digits:!0},creditcard:{creditcard:!0}},addClassRules:function(b,c){b.constructor===String?this.classRuleSettings[b]=c:a.extend(this.classRuleSettings,b)},classRules:function(b){var c={},d=a(b).attr("class");return d&&a.each(d.split(" "),function(){this in a.validator.classRuleSettings&&a.extend(c,a.validator.classRuleSettings[this])}),c},normalizeAttributeRule:function(a,b,c,d){/min|max|step/.test(c)&&(null===b||/number|range|text/.test(b))&&(d=Number(d),isNaN(d)&&(d=void 0)),d||0===d?a[c]=d:b===c&&"range"!==b&&(a["date"===b?"dateISO":c]=!0)},attributeRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)"required"===c?(d=b.getAttribute(c),""===d&&(d=!0),d=!!d):d=f.attr(c),this.normalizeAttributeRule(e,g,c,d);return e.maxlength&&/-1|2147483647|524288/.test(e.maxlength)&&delete e.maxlength,e},dataRules:function(b){var c,d,e={},f=a(b),g=b.getAttribute("type");for(c in a.validator.methods)d=f.data("rule"+c.charAt(0).toUpperCase()+c.substring(1).toLowerCase()),""===d&&(d=!0),this.normalizeAttributeRule(e,g,c,d);return e},staticRules:function(b){var c={},d=a.data(b.form,"validator");return d.settings.rules&&(c=a.validator.normalizeRule(d.settings.rules[b.name])||{}),c},normalizeRules:function(b,c){return a.each(b,function(d,e){if(e===!1)return void delete b[d];if(e.param||e.depends){var f=!0;switch(typeof e.depends){case"string":f=!!a(e.depends,c.form).length;break;case"function":f=e.depends.call(c,c)}f?b[d]=void 0===e.param||e.param:(a.data(c.form,"validator").resetElements(a(c)),delete b[d])}}),a.each(b,function(a,d){b[a]="function"==typeof d&&"normalizer"!==a?d(c):d}),a.each(["minlength","maxlength"],function(){b[this]&&(b[this]=Number(b[this]))}),a.each(["rangelength","range"],function(){var a;b[this]&&(Array.isArray(b[this])?b[this]=[Number(b[this][0]),Number(b[this][1])]:"string"==typeof b[this]&&(a=b[this].replace(/[\[\]]/g,"").split(/[\s,]+/),b[this]=[Number(a[0]),Number(a[1])]))}),a.validator.autoCreateRanges&&(null!=b.min&&null!=b.max&&(b.range=[b.min,b.max],delete b.min,delete b.max),null!=b.minlength&&null!=b.maxlength&&(b.rangelength=[b.minlength,b.maxlength],delete b.minlength,delete b.maxlength)),b},normalizeRule:function(b){if("string"==typeof b){var c={};a.each(b.split(/\s/),function(){c[this]=!0}),b=c}return b},addMethod:function(b,c,d){a.validator.methods[b]=c,a.validator.messages[b]=void 0!==d?d:a.validator.messages[b],c.length<3&&a.validator.addClassRules(b,a.validator.normalizeRule(b))},methods:{required:function(b,c,d){if(!this.depend(d,c))return"dependency-mismatch";if("select"===c.nodeName.toLowerCase()){var e=a(c).val();return e&&e.length>0}return this.checkable(c)?this.getLength(b,c)>0:void 0!==b&&null!==b&&b.length>0},email:function(a,b){return this.optional(b)||/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(a)},url:function(a,b){return this.optional(b)||/^(?:(?:(?:https?|ftp):)?\/\/)(?:(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})+(?::(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(a)},date:function(){var a=!1;return function(b,c){return a||(a=!0,this.settings.debug&&window.console&&console.warn("The `date` method is deprecated and will be removed in version '2.0.0'.\nPlease don't use it, since it relies on the Date constructor, which\nbehaves very differently across browsers and locales. Use `dateISO`\ninstead or one of the locale specific methods in `localizations/`\nand `additional-methods.js`.")),this.optional(c)||!/Invalid|NaN/.test(new Date(b).toString())}}(),dateISO:function(a,b){return this.optional(b)||/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(a)},number:function(a,b){return this.optional(b)||/^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a)},digits:function(a,b){return this.optional(b)||/^\d+$/.test(a)},minlength:function(a,b,c){var d=Array.isArray(a)?a.length:this.getLength(a,b);return this.optional(b)||d>=c},maxlength:function(a,b,c){var d=Array.isArray(a)?a.length:this.getLength(a,b);return this.optional(b)||d<=c},rangelength:function(a,b,c){var d=Array.isArray(a)?a.length:this.getLength(a,b);return this.optional(b)||d>=c[0]&&d<=c[1]},min:function(a,b,c){return this.optional(b)||a>=c},max:function(a,b,c){return this.optional(b)||a<=c},range:function(a,b,c){return this.optional(b)||a>=c[0]&&a<=c[1]},step:function(b,c,d){var e,f=a(c).attr("type"),g="Step attribute on input type "+f+" is not supported.",h=["text","number","range"],i=new RegExp("\\b"+f+"\\b"),j=f&&!i.test(h.join()),k=function(a){var b=(""+a).match(/(?:\.(\d+))?$/);return b&&b[1]?b[1].length:0},l=function(a){return Math.round(a*Math.pow(10,e))},m=!0;if(j)throw new Error(g);return e=k(d),(k(b)>e||l(b)%l(d)!==0)&&(m=!1),this.optional(c)||m},equalTo:function(b,c,d){var e=a(d);return this.settings.onfocusout&&e.not(".validate-equalTo-blur").length&&e.addClass("validate-equalTo-blur").on("blur.validate-equalTo",function(){a(c).valid()}),b===e.val()},remote:function(b,c,d,e){if(this.optional(c))return"dependency-mismatch";e="string"==typeof e&&e||"remote";var f,g,h,i=this.previousValue(c,e);return this.settings.messages[c.name]||(this.settings.messages[c.name]={}),i.originalMessage=i.originalMessage||this.settings.messages[c.name][e],this.settings.messages[c.name][e]=i.message,d="string"==typeof d&&{url:d}||d,h=a.param(a.extend({data:b},d.data)),i.old===h?i.valid:(i.old=h,f=this,this.startRequest(c),g={},g[c.name]=b,a.ajax(a.extend(!0,{mode:"abort",port:"validate"+c.name,dataType:"json",data:g,context:f.currentForm,success:function(a){var d,g,h,j=a===!0||"true"===a;f.settings.messages[c.name][e]=i.originalMessage,j?(h=f.formSubmitted,f.resetInternals(),f.toHide=f.errorsFor(c),f.formSubmitted=h,f.successList.push(c),f.invalid[c.name]=!1,f.showErrors()):(d={},g=a||f.defaultMessage(c,{method:e,parameters:b}),d[c.name]=i.message=g,f.invalid[c.name]=!0,f.showErrors(d)),i.valid=j,f.stopRequest(c,j)}},d)),"pending")}}});var c,d={};return a.ajaxPrefilter?a.ajaxPrefilter(function(a,b,c){var e=a.port;"abort"===a.mode&&(d[e]&&d[e].abort(),d[e]=c)}):(c=a.ajax,a.ajax=function(b){var e=("mode"in b?b:a.ajaxSettings).mode,f=("port"in b?b:a.ajaxSettings).port;return"abort"===e?(d[f]&&d[f].abort(),d[f]=c.apply(this,arguments),d[f]):c.apply(this,arguments)}),a});

// jquery validation plugin code end here
 
  /* Config box number of kids selectbox */
  const portionSelectItem = document.querySelectorAll('#js-portion-select li');
  const portionInput = document.querySelector('#js-portion-selected');
  const portionText =  document.querySelector('#js-portion-text');
  const numberKidsVal = document.querySelector('#js-portion-selected-text');
  const portionSelectToggle = document.querySelector('#js-portion-toggle');
 
  portionSelectToggle.addEventListener('mouseover', (event) => {
   portionSelectToggle.classList.add('is-open');
  });
 
   portionSelectToggle.addEventListener('mouseout', (event) => {
     portionSelectToggle.classList.remove('is-open');
   });
  
 
   if(portionSelectItem) {
     portionSelectItem.forEach(function(portionItem,index) {
       portionItem.addEventListener('click',function(){       
         let portionSelectedText = this.dataset.portion;
         portionInput.value = portionItem.innerHTML;
         numberKidsVal.innerHTML = portionItem.innerHTML;
         portionText.innerHTML = portionSelectedText;
         if(portionSelectToggle.classList.contains('is-open')) {
           setTimeout(function(){
             portionSelectToggle.classList.remove('is-open');
           },100);
         }
       })
     });
   }
 
 
 
   /* config meals selectbox */
   const mealSelectedItem = document.querySelectorAll('#js-meals-select li');
   const mealVal = document.querySelector('#js-meal-selected-text');
   const mealInput = document.querySelector('#js-meals-selected');
   const mealSelectToggle = document.querySelector('#js-meal-toggle');
 
   mealSelectToggle.addEventListener('mouseover', (event) => {
     mealSelectToggle.classList.add('is-open');
   });
   
   mealSelectToggle.addEventListener('mouseout', (event) => {
     mealSelectToggle.classList.remove('is-open');
   });
 
   if(mealSelectedItem) {
     mealSelectedItem.forEach(function(mealItem,index) {
       mealItem.addEventListener('click',function(){
         mealInput.value = mealItem.innerHTML;
         mealVal.innerHTML = mealItem.innerHTML;
         if(mealSelectToggle.classList.contains('is-open')) {
           setTimeout(function(){
             mealSelectToggle.classList.remove('is-open');
           },500);
         }
       });
     });
   }
 
   const sousRadios = document.querySelectorAll('input[name="devices"]');
   const sousImg = document.querySelector('#js-sous-img');
 
   /* if sous is not selected */
   if(sousRadios) {
     sousRadios.forEach(function(sousRadio,index) {
       sousRadio.addEventListener('click',function(){
         if(sousRadio.id == 'noDevice') {
           sousImg.style.display = 'none';
         }
         if(sousRadio.id == 'withDevice') {
           sousImg.style.display = 'block';
         }
       });
     });
   }
 
   /* ================================
   popup config
   =================================== */
 
   /* number of kids popup */
   var numberKidsInfoBtn = document.querySelector('.js-config-kids-info');
   if(numberKidsInfoBtn) {
     numberKidsInfoBtn.addEventListener('click', function() {
       new Modal({el: document.getElementById('js-modal-kids')}).show(); 
     });
   }
 
   /* meals popup */
   var mealsInfoBtn = document.querySelector('.js-config-meals-info');
   if(mealsInfoBtn) {
     mealsInfoBtn.addEventListener('click', function() {
       new Modal({el: document.getElementById('js-modal-meals')}).show(); 
     });
   }
 
   /* meal preference popup */
   var preferenceInfoBtn = document.querySelector('.js-config-preference-info');
   if(preferenceInfoBtn) {
     preferenceInfoBtn.addEventListener('click', function() {
       new Modal({el: document.getElementById('js-modal-preference')}).show(); 
     });
   }
 
   /* additional meals preference popup */
   var addPreferenceInfoBtn = document.querySelector('.js-config-add-preference-info');
   if(addPreferenceInfoBtn) {
     addPreferenceInfoBtn.addEventListener('click', function() {
       new Modal({el: document.getElementById('js-modal-add-preference')}).show(); 
     });
   }
   
   /* device wide popup */
   var deviceInfoBtn = document.querySelector('.js-config-device-info');
   if(deviceInfoBtn) {
     deviceInfoBtn.addEventListener('click', function() {
       new Modal({el: document.getElementById('js-modal-device')}).show(); 
     });
   }


  /* meals accounting popup */
  var deviceInfoBtn = document.querySelector('.js-config-meals-accounting');
  if(deviceInfoBtn) {
    deviceInfoBtn.addEventListener('click', function() {
      new Modal({el: document.getElementById('js-modal-meals-accounting')}).show(); 
    });
  }
 
   /* order preference popup */
   var orderPreferenceInfoBtn = document.querySelector('.js-config-order-preference-info');
   if(orderPreferenceInfoBtn) {
     orderPreferenceInfoBtn.addEventListener('click', function() {
       new Modal({el: document.getElementById('js-order-preference-device')}).show(); 
     });
   }
 
   /* delivery summary popup */
   var deliverySummaryBtn = document.querySelector('.js-delivery-info');
   if(deliverySummaryBtn) {
     deliverySummaryBtn.addEventListener('click', function() {
       new Modal({el: document.getElementById('js-delivery-summary')}).show(); 
     });
   }
 
   /* go to cart */
  //  var goToCartBtn = document.querySelector('.js-go-to-cart');
  //  var backToConfigBtn = document.querySelector('.js-back-to-selection');
  //  var cartStep = document.querySelector('.js-cart-step');
  //  var configStep = document.querySelector('.js-config-step');
 
  //  goToCartBtn.addEventListener('click',function(){
  //    cartStep.classList.add('is-active');
  //    configStep.classList.remove('is-active');
  //  });
 
  //  backToConfigBtn.addEventListener('click',function(){
  //    cartStep.classList.remove('is-active');
  //    configStep.classList.add('is-active');
  //  });
 
 
   // sidebar configuration code start here
 
   
 $( document ).ready(function() {
 
   
 var referrer =  document.referrer;
 if (referrer.indexOf("cart") != -1){
   preselector();  
   setTimeout(function(){
    $('.js-go-to-cart').trigger("click");  
    $('#js-slider-config').addClass('is-active');
    $('.js-config-step').removeClass('is-active');  
    $('.js-cart-step').addClass('is-active');
 },2000)
 }
 
 /* trial order */
 if( $('.config-box--order-trial #ABO-trial').is(':checked') )
  { 
    console.log('abo selected')
    $('.selected-prefrence-price-trial').html('2,99');
  }else{
    console.log('flex selected')
    $('.selected-prefrence-price-trial').html('3,50');
  }
/* trial order */


  /* =============================================
   configure box open close code start here
   ============================================= */
 
    //  /* config slider open code  */
   
  $(".js-config-slider-plan-page").click(function(){ 
   var plan_selected_val = $(this).attr("selected-plan"); 
   if(plan_selected_val){
   $("input[name=orderPreference][id='"+plan_selected_val+"']").prop("checked",true).trigger("click");
   } 
     ready_sidebar();
   setTimeout(function(){
    //$('#js-slider-config').addClass('is-active');
    $('.slider__body--popup').removeClass('hidden-popup');
    $('html').addClass('is-slider-active');   
    $('.slider-bg-overlay').addClass('is-active');
 },1000);
  })
 
    //  /* Config Close button slider */
   
  $(".js-config-return").click(function(){
   //  $('#js-slider-config').removeClass('is-active');
   //   $('html').removeClass('is-slider-active');
   //   $('.slider-bg-overlay').removeClass('is-active');
   $('.form-config-child-class input').val("")
   $(".submit-button-br").addClass('submit-button-br-togg')
   $('.bottom-header').hide();
   $('.confetti-image').hide();
   $(".rotate-image").removeClass("rotateImage");
   $(".rotate-image").show();
    setTimeout(function(){
    $('.js-cart-step').removeClass('is-active');
    $('.js-config-step').addClass('is-active'); 
   },500);
  })  
 
     // /* go to cart */
   
 $(".js-go-to-cart").click(function(){  

  product_price_change();
  
  if($("#about-parent-meals-accounting").is(":checked")){
    $(".summery-meals-accounting").show();
    $('.summery-meals-accounting .order-summary__item-detail').text($("#about-parent-meals-accounting").closest('.form__radio-wrapper').find('.form__radio-label').text());

  }else{
    $(".summery-meals-accounting").hide();
    $('.summery-meals-accounting .order-summary__item-detail').text($("#about-daycare-meals-accounting").closest('.form__radio-wrapper').find('.form__radio-label').text());
  }

  if($('#js-portion-select li.active').attr('data-quantity') > 50){    
    $('.product-third-step-config').addClass('is-active');
    $('.js-config-step').removeClass('is-active');    
  }else{
    // $('.js-cart-step').addClass('is-active');
    $('.js-config-step').removeClass('is-active');
  }

 })

 $(".js-go-to-third-step").click(function(){
  $('.product-third-step-config').addClass('is-active');
  $('.js-cart-step').removeClass('is-active');
  $('.step-six-wrap').addClass('is-active-show')
 })
 $(".step-five-wrap .js-go-to-third-step").click(function(){
  $('.step-six-wrap').addClass('is-active-show')
  $(document).find('.step-six-wrap').addClass('is-active-show').css('display', 'block');
 })
 
 $(".js-back-to-first-step").click(function(){
  $('.js-cart-step').removeClass('is-active');
  $('.js-config-step').addClass('is-active');
  $('.step-six-wrap').removeClass('is-active-show');
  $('.step-four-wrap .slider__step').removeClass('is-active');
})

 $(".js-back-to-selection").click(function(){
  if($('#js-portion-select li.active').attr('data-quantity') > 30){    
    $('.js-config-step').addClass('is-active');
    $('.product-third-step-config').removeClass('is-active');    
  }else{
    $('.product-third-step-config').removeClass('is-active');    
    $('.js-cart-step').addClass('is-active');  
  }

  $('.form-config-child-class input').val("")
  $(".submit-button-br").addClass('submit-button-br-togg')
  $('.bottom-header').hide();
  $('.confetti-image').hide();
  $(".rotate-image").removeClass("rotateImage");
  $(".rotate-image").show();

})
$(".slider__order-summary .js-back-to-selection").click(function(){
  $('.js-cart-step').removeClass('is-active');    
  //$('.js-config-step').addClass('is-active');  
})

$(".step-four-wrap .js-back-to-selection").click(function(){
  $(document).find('#js-slider-config').removeClass('is-active');
  $(document).find('.step-five-wrap .slider__step').removeClass('is-active');
})

 
//  js-back-to-first-step
//  $(".js-go-to-third-step").click(function(){
//   $('.product-third-step-config').addClass('is-active');
//   $('.js-cart-step').removeClass('is-active');
// })
 

 
 /* =============================================
  configure box open close code end here
  ============================================= */
 
 
 $("#js-meal-toggle, #js-portion-toggle").hover(
  function () {
  $(this).addClass("is-open");
  },
  function () {
  $(this).removeClass("is-open");
  }
 );  
  
 $( "#js-portion-select li" ).each(function() {
  $(this).on("click", function(){
    setTimeout(function(){
    $('#js-portion-toggle').removeClass("is-open");    
    },200);
  });     
 });
 
 $('#FLEX').click(function(){
  $("#withDevice").prop('disabled', false);
  $('#withDevice').removeClass('disable');
  $('.config-box__item.meals-accounting').show();
 })
   
 $('#ABO').click(function(){  
  $("#withDevice").prop('disabled', false);
  $('#withDevice').removeClass('disable');
  $('.config-box__item.meals-accounting').show();
 })
  
 $('#EINMALIG').click(function(){    
  $('#withDevice').prop('checked', false);
  $('#noDevice').prop('checked', true);
  $('#withDevice').addClass('disable')
  $("#withDevice").prop('disabled', true);
  $('.config-box__item.meals-accounting').hide();
 })
  
//  $("#js-portion-select li").click(function(){
//   var above30ValueAttr = $(".form__children-title input").attr('data-above30-value');
//   // console.log('above30ValueAttr=', above30ValueAttr);
  
//   // Split the string by commas and convert to an array of numbers
//   var above30Values = above30ValueAttr.split(',').map(Number);
  
//   // Log the array to ensure correct parsing
//   // console.log('above30Values=', above30Values);
  
//   // Check the under30Value
//   var under30Value = parseInt($('.form__children-title input').val(), 10); // Ensure under30Value is a number
//   // console.log('under30Value=', under30Value);
//   var minChildrenQunatiy = $(".form__children-title input").attr('min-childern');
//   var maxChildrenQunatiy = $(".form__children-title input").attr('max-childern');
  
//   // Use the array to check if under30Value matches any of the conditions
//   if (under30Value < minChildrenQunatiy || under30Value > maxChildrenQunatiy){
//     $('.last-submit-button').removeClass('final-cart-btn');
//     $('.last-submit-button').addClass('inquiry-form-submit-btn');
//     // $('.configurator30plus-main').show();
//     $('.configurator30plus-main').css('display', 'block'); // Force display block

//     $('.config-bottom-under-30').hide();
//     $('.order-summary').hide();
//     $('.delivery-summary').hide();
//     $('.config-bottom-above-30').show();
//     $('.js-config-step').removeClass('is-active');
//     // $('.js-cart-step').addClass('is-active');
//     $('.slider--config').addClass("is-active");
//   } else {
//     $('.last-submit-button').addClass('final-cart-btn');
//     $('.configurator30plus-main').hide();
//     $('.last-submit-button').removeClass('inquiry-form-submit-btn');
//     $('.order-summary').show();
//     $('.delivery-summary').show();
//     $('.config-bottom-under-30').show();
//     $('.config-bottom-above-30').hide();
//     // $('.js-cart-step').removeClass('is-active');
//     $('.js-config-step').addClass('is-active');
//   }
//   product_price_change(); 
//  });
 

 $(".form--configurator30").validate({
  ignore: ":hidden",
  rules: { 
          day_care_name:
          {
            required: true
          },    
          number_of_children:
          {
            required: true
          },
          address:
          {
            required: true
          },
          postcode:
          {
            required: true,
            maxlength: 5,
            minlength: 5
          },
          city:
          {
            required: true
          }, 
          first_name: 
          { 
            required: true
          },
          last_name: 
          {
              required: true
          },
          email: 
          { 
            required: true, 
            email: true 
          },
          phone: {
            required: true
          },
          additional_info: {
            required: true
          }      
      },
      messages: {
           day_care_name:
          {
            required: "Geben Sie den Namen der Tagespflege ein"
          },    
          number_of_children:
          {
            required: "Geben Sie die Anzahl der derzeit betreuten Kinder ein"
          },
          address:
          {
            required: "Bitte gültige Adresse angeben"
          },
          postcode:
          {
            required: "Bitte gültige 5-stellige Postleitzahi angeben",
            maxlength: "Bitte gültige 5-stellige Postleitzahi angeben",
            minlength: "Bitte gültige 5-stellige Postleitzahi angeben"
          },
          city:
          {
            required: "Bitte Stadt angeben" 
          }, 
          first_name: 
          { 
            required: "Bitte Vornamen angeben"
          },
          last_name: 
          {
            required: "Bitte Nachname angeben"
          },
          email: 
          { 
            required: "Bitte gültige Emailadresse angeben",
            email: "Bitte gültige Emailadresse angeben"
          },
          phone: {
            required: "Bitte Telefonnummer / Handynummer inkl. Vorwahl angeben"
          },
          additional_info:{
            required: "Bitte geben Sie zusätzliche Informationen an"
          }

      }
})

  $(document).on('click', '.inquiry-form-submit-btn', function() {
    if($(".form--configurator30").valid()){
      let customerData = {};
      customerData['Name_Kindertagespflege'] = $(".form--configurator30 input[name='day_care_name']").val();
      customerData['Vorname'] = $(".form--configurator30 input[name='first_name']").val();
      customerData['Nachname'] = $(".form--configurator30 input[name='last_name']").val();
      customerData['Anzahl_der_Betreuungstage'] = $(".form--configurator30 input[name='number_of_children']").val();
      customerData['Adresse'] = $(".form--configurator30 input[name='address']").val();
      customerData['PLZ'] = $(".form--configurator30 input[name='postcode']").val();
      customerData['Stadt'] = $(".form--configurator30 input[name='city']").val();      
      customerData['email'] = $(".form--configurator30 input[name='email']").val();
      customerData['Telefon'] = $(".form--configurator30 input[name='phone']").val();  
      customerData['Zusätzliche_Infos'] = $("#additional-info").val();    
      // customerData['Anzahl_Kinder'] = $(".sidebar-kinder").val();
      customerData['Anzahl_der_Wochengerichte'] = $(".send-email-weekly-dishes-field").val();
      customerData['Praferenz_der_Gerichte'] = $(".send-email-preference-dishes-field").val();
      customerData['Zusatzliche_Praferenz'] = $(".send-email-additional-preference-field").val();
      customerData['Bestellvariante'] = $(".send-email-order-variant-field").val();
      customerData['Sous_Vide_Gerat'] = $(".send-email-device-field").val();
      customerData['Abrechnung_der_verpflegung'] = $(".send-email-meals-accounting").val();    
      
      customerData['formType'] = "30plus";
      
      // console.log(customerData);
if(customerData.Anzahl_der_Betreuungstage == ""){
//  console.log('blank');
}else{
 // console.log('fill');
  $.ajax({
    url : "https://checkout.chinuki.de/customer_inquiry/",
    method : "POST",
    dataType : "JSON",
    contentType: "application/json; charset=utf-8",
    data :JSON.stringify(customerData),
    success : function(data) {
    //  console.log("Sent email")
    },
    error : function(data) {
      console.log('error');
    }  
  });
}


$('.inquiry-form-submit-btn').addClass('form-successfuly-sent');
$('.configurator30__title').hide();
$('.form--configurator30').hide();
$('.form-successfull-msg').show();
$('.form--configurator30')[0].reset();
setTimeout(function(){
  if ($(".inquiry-form-submit-btn").hasClass("form-successfuly-sent")) {
$('#js-close-config').click();
$(".slider__body--popup").addClass('hidden-popup');
$(".slider-bg-overlay").removeClass("is-active");

  }
},5000)
setTimeout(function(){
  if ($(".inquiry-form-submit-btn").hasClass("form-successfuly-sent")) {
  //  console.log('found');
  $('.js-cart-step').removeClass('is-active');
  $('.inquiry-form-submit-btn').removeClass('form-successfuly-sent');
  $('.js-config-step').addClass('is-active');
  $('.form-successfull-msg').hide();
  $('.configurator30__title').show();
  $('.form--configurator30').show();
  }
  },6500)
    }
 })
 
 $("#agreecondition").change(function() {
  if(this.checked) {
     $('.last-submit-button').prop('disabled', false);  
  }else{
      $('.last-submit-button').prop('disabled', true);  
  }
});

 $(document).on('click','.form-successfuly-sent',function(){ 
  $('.inquiry-form-submit-btn').removeClass('form-successfuly-sent');
  $('#js-close-config').click();   
  setTimeout(function(){
  $('.js-cart-step').removeClass('is-active');
  $('.js-config-step').addClass('is-active');
  $('.form-successfull-msg').hide();
  $('.configurator30__title').show();
  $('.form--configurator30').show();
},500)
 })
 

 $.validator.addMethod("pattern", function(value, element, param) {
  return this.optional(element) || param.test(value);
}, "Invalid format");

 $(".send-quote-form").validate({
  ignore: ":hidden",
  rules: { 
    quote_email:
          {
            required: true,
            email: true,
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          }
        },
  messages: {
    quote_email:
          {
            required: "Bitte gültige Emailadresse angeben",
            email: "Bitte gültige Emailadresse angeben",
            pattern: "Bitte geben Sie eine gültige Emailadresse ein"
          }
        },
    errorPlacement: function(error, element) {
      if (element.attr("name") === "quote_email") {
        error.appendTo(element.closest(".form__row").find(".e-mail-error"));
      }
    }
    
}) 


$(document).on('click', '.send-quote-submit-btn', function() {
  if($(".send-quote-form").valid()){
    
    let mealData = {};
      mealData['kids_number'] = $('.sidebar-kinder').val(); 
      mealData['days_number'] = $('#js-meals-select li.active').text();
      mealData['meal_preference'] = $('input[name="mealPreference"]:checked').attr('data-preference-value');
      mealData['dish_preference'] = $('input[name="addPrefernce"]:checked').attr('data-addi-preference-value');
      mealData['order_preference'] = $('input[name="orderPreference"]:checked').attr('id');
      mealData['order_price'] = $('input[name="orderPreference"]:checked').attr('data-plan-price');
      mealData['device_preference'] = $('input[name="devices"]:checked').attr('data-device-attr');
      mealData['device_price'] = $('input[name="devices"]:checked').attr('data-pro-price');
      mealData['billing_preference'] = $('input[name="meals-accounting"]:checked').attr('data-meal-accounting');

    let mealTotalData = {};
      mealTotalData['coast_food_total'] = $('.multiplied-price').html();
      mealTotalData['coast_selected_device'] = $('.selected-device-price-new').html();
      mealTotalData['coast_shipping'] = $('.product-ship-price').html();
      mealTotalData['coast_net_amount'] = $('.selected-price').html();
      mealTotalData['coast_tax'] = $('.tax-selected-price').html();
      mealTotalData['coast_gross_amount'] = $('.order-summery-total-price--price').html();

    let parentsTotalData = {};

    if(mealData['billing_preference'] == 'Über Eltern'){
      parentsTotalData['parents_food_total'] = $('.tax-multiplied-price').html();
      parentsTotalData['parents_rental_share'] = $('.it-show-device-per-price').html();
      parentsTotalData['parents_processing_fees'] = $('.processing-fees').html();
      parentsTotalData['parents_shipping_coast'] = $('.it-show-shipping-per-price').html();
      parentsTotalData['parents_net_amount'] = $('.new-order-summery-total-price span').html();
      parentsTotalData['parents_tax'] = $('.order-summery-total-price-overtax-price').html();
      parentsTotalData['parents_gross_amount'] = $('.order-summery-total-tax-price-parent').html();
    }

    let customerData = {};
      customerData['quote_email'] = $(".send-quote-form input[name='quote_email']").val();

      console.log(mealData);
      console.log(mealTotalData);
      console.log(parentsTotalData);
      console.log(customerData);
    
    $.ajax({
      url : "https://checkout.chinuki.de/send/quote/",
      method : "POST",
      dataType : "JSON",
      contentType: "application/json; charset=utf-8",
      data : JSON.stringify({ 
        mealData : mealData,
        mealTotalData : mealTotalData,
        parentsTotalData: parentsTotalData,
        customerData: customerData
      }),
      success : function(data) {
          console.log("Sent Quote email");
          $('.send-quote-step .slider__body').hide();
          $('.send-quote-step .slider__footer').hide();
          $('.quote-form-successfull-msg').show();

      },
      error : function(data) {
        console.log('error');
      }  
    });

  }
})

 $(document).on('click','#js-meals-select li',function(){    
  setTimeout(function(){
    $('#js-meal-toggle').removeClass("is-open");
  },100);
  jQuery(this).addClass('active').siblings().removeClass('active');
  var menu_dishes = $("#js-meals-select li.active").text();
  $('#js-meal-selected-text').html(menu_dishes);
  setTimeout(function(){
    product_selector();    
  },500);
 })
 
 $(document).on('change', 'input[name=mealPreference]:radio', function() {
  setTimeout(function(){
    product_selector();   
  },500);
 })
 
 $(document).on('change', 'input[name=addPrefernce]:radio', function() {
  setTimeout(function(){
    product_selector();    
  },500);
 })
 
 $(document).on('change', 'input[name=devices]:radio', function() {
  setTimeout(function(){
    product_selector();    
  },500);
 })

 $('.sidebar-kinder').on('input change', function() {
  setTimeout(function(){
    product_selector();   
  },2000);
 })
 
 $(document).on('change', 'input[name=orderPreference]:radio', function() {
    ready_sidebar();
 })
 
 //  -------- code for get device variant price staticaly using product handle code start here -------------
 let abo_device_price_var_1 = ""
 let abo_device_price_var_2 = ""
 let abo_device_price_var_3 = ""
 
 let flex_device_price_var_1 = ""
 let flex_device_price_var_2 = ""
 let flex_device_price_var_3 = ""
 
 let abo_device_image_var_1 = ""
 let abo_device_image_var_2 = ""
 let abo_device_image_var_3 = ""
 
 let flex_device_image_var_1 = ""
 let flex_device_image_var_2 = ""
 let flex_device_image_var_3 = ""
 
 jQuery.getJSON('/products/chinuki-device-abo-product.js', function(data12) {     
    abo_device_price_var_1 = Number.parseFloat(data12.variants[0].price / 100).toFixed(2);   
    abo_device_price_var_2 = Number.parseFloat(data12.variants[1].price / 100).toFixed(2);   
    abo_device_price_var_3 = Number.parseFloat(data12.variants[2].price / 100).toFixed(2); 
    abo_device_image_var_1 = data12.variants[0].featured_image.src;
    abo_device_image_var_2 = data12.variants[1].featured_image.src;
    abo_device_image_var_3 = data12.variants[2].featured_image.src;
 })
 
 jQuery.getJSON('/products/chinuki-device-flex-product.js', function(data12) {  
    flex_device_price_var_1 = Number.parseFloat(data12.variants[0].price / 100).toFixed(2);
    flex_device_price_var_2 = Number.parseFloat(data12.variants[1].price / 100).toFixed(2);
    flex_device_price_var_3 = Number.parseFloat(data12.variants[2].price / 100).toFixed(2); 
    flex_device_image_var_1 = data12.variants[0].featured_image.src;
    flex_device_image_var_2 = data12.variants[1].featured_image.src;
    flex_device_image_var_3 = data12.variants[2].featured_image.src;
 })
 
 //  -------- code for get device variant price staticaly using product handle code end here -------------
 
 ready_sidebar();  
  
 function ready_sidebar(){  
  var get_pro_handle = $('input[name="orderPreference"]:checked').attr('data-product-handle');  
  var get_abo_device_handle = $('input[name="devices"]:checked').attr('data-device-handle-abo');  
  var get_flex_device_handle = $('input[name="devices"]:checked').attr('data-device-handle-flex');  
 
 var previous_selected_meals = $("#js-meals-select li.active").text();   
 var previous_mealPreference = $('input[name="mealPreference"]:checked').attr('data-preference-value');
 var previous_addPrefernce = $('input[name="addPrefernce"]:checked').attr('data-addi-preference-value');
 
 
 jQuery.getJSON('/products/' + get_pro_handle + '.js', function(data2) {    
  var sidebar_structure_deshes = "";
  var meal_preference = "";
  var meal_add_preference = "";
 
    //  ------------ code for weekly dished get  -------------
  
    $(data2.options[0]).each(function (key,value){    
      $(value.values).each(function (im,em){      
      var get_menu_dishes = em;
      get_menu_dishes_clear = get_menu_dishes.replace(/\D/g,'');            
      if ( im === 0) {
      var active_denim = "active";
      }
      sidebar_structure_deshes += '<li  data-meals-value="'+get_menu_dishes+'" class="'+active_denim+'">'+get_menu_dishes_clear+'</li>';
      })      
      $('#js-meals-select').html(sidebar_structure_deshes);
 
      $('#js-meals-select li').each(function(i, li) {
          if($(li).text() == previous_selected_meals){
              $(this).addClass('active').siblings().removeClass('active'); 
          }
      })
      var menu_dishes = $("#js-meals-select li.active").text();
      $('#js-meal-selected-text').html(menu_dishes);
  })
 
 //  ------------ code for preference of your dishes get  -------------
  
 const params = new URLSearchParams(window.location.search);
 const urlParamsMeal = params.get('meal');

 $(data2.options[1]).each(function (key1,value1){        
  $(value1.values).each(function (im1,em1){      

    if(urlParamsMeal){
      if(urlParamsMeal == em1){
        var checkec_pref_radio = "checked";
      }
    }else {
      if(previous_mealPreference === undefined){
        if ( im1 === 0) {
          var checkec_pref_radio = "checked";
          }   
      }else{
        if(previous_mealPreference == em1){
          var checkec_pref_radio = "checked";
        }
      }
    }
  
  meal_preference += '<div class="pure-u-1-2 pure-u-md-1-2">\
  <div class="form__radio-wrapper">\
  <input type="radio" class="form__radio" name="mealPreference" id="'+em1+'" data-preference-value="'+em1+'" '+checkec_pref_radio+'>\
  <label for="'+em1+'" class="form__radio-label">'+em1+'</label>\
  </div>\
  </div>';
  })      
  $('.config-box--preference .form__row').html(meal_preference);  
 })
 
 //  ------------ code for Additional Preference get  -------------
 
 
 $(data2.options[2]).each(function (key2,value2){  
  $(value2.values).each(function (im2,em2){    
 
  if(previous_addPrefernce === undefined){
    if ( im2 === 0) {
      var checkec_add_pref_radio = "checked";
      }       
  }else{
    if(previous_addPrefernce == em2){
      var checkec_add_pref_radio = "checked";
    }
  }
 
  meal_add_preference += '<div class="pure-u-1-2 pure-u-md-1-2">\
  <div class="form__radio-wrapper">\
  <input type="radio" class="form__radio" name="addPrefernce" id="'+em2+'" data-addi-preference-value="'+em2+'" '+checkec_add_pref_radio+'>\
  <label for="'+em2+'" class="form__radio-label">'+em2+'</label>\
  </div>\
  </div>';
  })      
  $('.config-box--additional-preference .form__row').html(meal_add_preference);  
 })
 
  //  ----------- Product variant selector code --------------
 
  var variant_structure = [];
  for (let i = 0; i < data2.variants.length; i++){                        
 var new_pro_title = data2.variants[i].title;         
 var new_pro_id =data2.variants[i].id;
 //  var new_pro_feature_img = data2.variants[i].featured_image.src; 
 if(data2.variants[i].featured_image != null ){          
  var new_pro_feature_img = data2.variants[i].featured_image.src;
 }else{
  var new_pro_feature_img = data2.featured_image;
 }       
 var new_pro_price=data2.variants[i].price; 
  var pri_update =  parseFloat(new_pro_price / 100);  
  variant_structure += '<option data-attr="'+new_pro_title+'" value='+data2.variants[i].id+' data-option1="'+data2.variants[i].option1+'" data-option2="'+data2.variants[i].option2+'" data-option3="'+data2.variants[i].option3+'" data-price="'+pri_update+'" data-var-img="'+new_pro_feature_img+'">'+new_pro_title+'</option>';              
  $("#product-variant-list").html(variant_structure);          
 }  
 
 if( $('#ABO').is(':checked') || $('#FLEX').is(':checked')){
  var iqf = $(data2.selling_plan_groups[0].selling_plans[0].id);          
  $('input[name="orderPreference"]:checked').attr('data-sell_id', iqf[0]);   
 }
 })
 if($('#noDevice').is(':checked')){
  $('#js-sous-img').hide();
 } 
 
 if( $('#ABO').is(':checked') && $('#withDevice').is(':checked')){
   // console.log('abo selected');
  jQuery.getJSON('/products/' + get_abo_device_handle + '.js', function(data22) {        
    var device_selling_id = $(data22.selling_plan_groups[0].selling_plans[0].id);           
    $('input[name="devices"]:checked').attr('data-sell_id', device_selling_id[0]); 
    }) 
 }
 if( $('#FLEX').is(':checked') && $('#withDevice').is(':checked')){
   // console.log('flex selected');
  jQuery.getJSON('/products/' + get_flex_device_handle + '.js', function(data22) {        
    var device_selling_id = $(data22.selling_plan_groups[0].selling_plans[0].id);                 
    $('input[name="devices"]:checked').attr('data-sell_id', device_selling_id[0]); 
    })
 }
 if( $('#EINMALIG').is(':checked')){
   $('#withDevice').prop('checked', false);
   $('#noDevice').prop('checked', true);
   $('#withDevice').addClass('disable')
   $("#withDevice").prop('disabled', true);
   $('.config-box__item.meals-accounting').hide();
 }
 
 setTimeout(function(){
  product_selector();    
 },1000);
 }  
  
 
 function product_selector(){  
  let demoats = [];
  let myVar2 = [];          
  var menu_dishes_selected = "";
  var menu_prefe_selected = "";
  var menu_addi_prefe_selected = "";
  menu_dishes_selected = $("#js-meals-select li.active").attr('data-meals-value');
  menu_prefe_selected = $('input[name="mealPreference"]:checked').attr('data-preference-value');
  menu_addi_prefe_selected = $('input[name="addPrefernce"]:checked').attr('data-addi-preference-value');
  demoats.push(menu_dishes_selected);
  demoats.push(menu_prefe_selected);
  demoats.push(menu_addi_prefe_selected);       
  myVar2 = demoats.join(' / ');      
    $("#product-variant-list option").each(function(){           
      var d_option = $(this).data('attr');                                 
      if( d_option == myVar2 ){
      var demnstar = $(this).attr('value');       
      $(this).attr('selected', true).siblings().attr('selected', false);        
      $('.final-cart-btn').attr('data-pro-id', demnstar);    
      var sel_var_img = $('#product-variant-list :selected').data("var-img");
      $('.config-box__variant-img img').attr("src",sel_var_img);         
      }        
  }) 
    $('#js-portion-selected-text').html($('.sidebar-kinder').val());
    var above30ValueAttr = $(".form__children-title input").attr('data-above30-value');
    var above30Values = above30ValueAttr.split(',').map(Number);
    var under30Value = parseInt($('.form__children-title input').val(), 10); // Ensure under30Value is a number
    var minChildrenQunatiy = $(".form__children-title input").attr('min-childern');
    var maxChildrenQunatiy = $(".form__children-title input").attr('max-childern');

    if (under30Value < minChildrenQunatiy || under30Value > maxChildrenQunatiy){
      $('.last-submit-button').removeClass('final-cart-btn')
      $('.last-submit-button').addClass('inquiry-form-submit-btn')    
      $('.configurator30plus-main').css('display', 'block'); // Force display block

      $('.config-bottom-under-30').hide()
      $('.order-summary').hide()
      $('.delivery-summary').hide()  
      $('.config-bottom-above-30').show()

    }else{
      $('.last-submit-button').addClass('final-cart-btn')
      $('.configurator30plus-main').hide()
      $('.last-submit-button').removeClass('inquiry-form-submit-btn') 
      $('.order-summary').show()   
      $('.delivery-summary').show()  
      $('.config-bottom-under-30').show()
      $('.config-bottom-above-30').hide()

    }
    product_price_change()    
 }

 function safeNumberConversion(value) {
  // Ensure the value is a valid string before attempting to replace
  if (value == null || value === "") {
    return 0; // Return 0 for null or empty strings
  }

  // If the value is a string, try to clean it and extract numbers
  if (typeof value === "string") {
    // Attempt to remove non-numeric characters, except for . and -
    value = value.replace(/[^0-9.-]/g, '');
  }

  // Parse the value to a float
  var parsedValue = parseFloat(value);

  // Return 0 if the value is not a valid number
  return isNaN(parsedValue) ? 0 : parsedValue;
}
 
 function product_price_change(){
  if( $('#ABO').is(':checked') && $('#withDevice').is(':checked')){
    var quantity_range = safeNumberConversion($('.sidebar-kinder').val());  // Safely convert quantity range
    if(quantity_range >= 4 && quantity_range <= 10){    
      var dp_price = safeNumberConversion(abo_device_price_var_1)   
      $('#withDevice').attr('data-pro-price', dp_price);
      $('#js-sous-img img').attr('src',abo_device_image_var_1) 
    }else if(quantity_range >= 11 && quantity_range <= 20){
      var dp_price = safeNumberConversion(abo_device_price_var_2)
      $('#withDevice').attr('data-pro-price', dp_price);
      $('#js-sous-img img').attr('src',abo_device_image_var_2) 
    }else if(quantity_range >= 21 && quantity_range <= 50){
      var dp_price = safeNumberConversion(abo_device_price_var_3)
      $('#withDevice').attr('data-pro-price', dp_price);
      $('#js-sous-img img').attr('src',abo_device_image_var_3) 
    }      
  }
 
  if( $('#FLEX').is(':checked') && $('#withDevice').is(':checked')){
    var quantity_range = $('.sidebar-kinder').val();
    if(quantity_range >= 4 && quantity_range <= 10){
      var dp_price = safeNumberConversion(flex_device_price_var_1)
      $('#withDevice').attr('data-pro-price', dp_price);
      $('#js-sous-img img').attr('src',flex_device_image_var_1) 
    }else if(quantity_range >= 11 && quantity_range <= 20){
      var dp_price = safeNumberConversion(flex_device_price_var_2)
      $('#withDevice').attr('data-pro-price', dp_price);
      $('#js-sous-img img').attr('src',flex_device_image_var_2) 
    }else if(quantity_range >= 21 && quantity_range <= 50){
      var dp_price = safeNumberConversion(flex_device_price_var_3)
      $('#withDevice').attr('data-pro-price', dp_price);
      $('#js-sous-img img').attr('src',flex_device_image_var_3) 
    }      
 }

 // Selected product price (ensure it's a valid number)
 var sel_pro_pri =  safeNumberConversion($('#product-variant-list :selected').data("price"));

 var quantity_range = $('.sidebar-kinder').val();

 // Portion text handling
 var change_portion_text = safeNumberConversion($('#js-portion-select li.active').attr('data-quantity'));

 if(change_portion_text >=1 && change_portion_text <=5){
   $('#js-portion-text').text($('.range_1-5').text());
 }
 if(change_portion_text >=6 && change_portion_text <=10){
   $('#js-portion-text').text($('.range_6-10').text());
 }
 if(change_portion_text >=11 && change_portion_text <=15){
   $('#js-portion-text').text($('.range_11-15').text());
 }
 if(change_portion_text >=16 && change_portion_text <=20){
   $('#js-portion-text').text($('.range_16-20').text());
 }
 if(change_portion_text >=21 && change_portion_text <=25){
   $('#js-portion-text').text($('.range_21-25').text());
 }
 if(change_portion_text >=26 && change_portion_text <=30){
   $('#js-portion-text').text($('.range_26-30').text());
 }

 // Price calculation with or without device
 var multiply_var_price;

 if(change_portion_text > 30){
   $('#js-portion-text').text($('.range_30plus').text());
 }
 if($('#withDevice').is(':checked')){  
  var votevalue = safeNumberConversion(dp_price);

  var multiply_var_price = (quantity_range*sel_pro_pri)+votevalue;   
 }
 if($('#noDevice').is(':checked')){
  var multiply_var_price = (quantity_range*sel_pro_pri);
 }

 // Ensure multiply_var_price is a valid number after the calculation 
 multiply_var_price = safeNumberConversion(multiply_var_price);

 // Formatting the final price for display
 var step_price = Number.parseFloat(multiply_var_price).toFixed(2);
 var final_step_price = step_price.toString().replace('.', ',');
 $('.config-box__price').html(final_step_price);
  //  console.log('final_step_price=',final_step_price)




// new configurator adjustment js code start here

var nca_multiply_var_price = (quantity_range*sel_pro_pri);
//console.log(nca_multiply_var_price);
var nfs = Number.parseFloat(nca_multiply_var_price).toFixed(2);
var nfs_format = nfs.toString().replace('.', ',');
$('.multiplied-price').html(nfs_format);
$('.producttotalqty').html(quantity_range*$("#js-meals-select li.active").text())
$('.productmealstotalqty').html($('#js-meals-select li.active').text());
var drs = Number.parseFloat(sel_pro_pri).toFixed(2);
var drs_format = drs.toString().replace('.', ',');
$('.tax-multiplied-price').html(drs_format);
//console.log(quantity_range*$("#js-meals-select li.active").text());
// new configurator adjustment js code ends here






 }

 
 // ---------- code for auto preselect variant value function code start here 
 
 setTimeout(function(){
  preselector();
 }, 1000)
 
 function preselector(){
 
 var prev_selectore = localStorage.getItem("preselected_variant_list");
 var prev_selected_options = JSON.parse(localStorage.getItem('preselected_option'));
 
 if (prev_selectore == null){  
 }
 else{    
  var create_arry = [];
 $.each(prev_selectore.split(" / "), function(){
     create_arry.push($.trim(this));
 });   
 $.each(create_arry, function(index, value){          
     $('.config-box__item input:radio').each(function(){
         var curr_selected_radion = $(this).attr('id');
         if(value == curr_selected_radion){
             $(this).prop('checked', true)
         }
     })
     $('#js-meals-select li').each(function(){
         var curr_selected_radion = $(this).attr('data-meals-value');            
         if(value == curr_selected_radion){
             $(this).addClass('active').siblings().removeClass('active');             
             $('#js-meal-selected-text').html($("#js-meals-select li.active").text());
         }
     }) 
 })
 }
 
 if (prev_selected_options == null){ 
 }else{
 $('#js-portion-select li').each(function(){
  var curr_selected_radion_portion = $(this).text();            
  if(prev_selected_options[0].selected_qty == curr_selected_radion_portion){
      $(this).addClass('active').siblings().removeClass('active');             
      $('#js-portion-selected-text').html($("#js-portion-select li.active").text());
  }
 })  
 $('.config-box__item input:radio').each(function(){
  var curr_selected_radion = $(this).attr('id');
  if(prev_selected_options[0].selcted_device == curr_selected_radion){
      $(this).prop('checked', true)
  }
 })
 $('.config-box__item input:radio').each(function(){
  var curr_selected_radion = $(this).attr('id');
  if(prev_selected_options[0].selected_order == curr_selected_radion){
      $(this).prop('checked', true)
  }
 })

 $('.config-box__item.meals-accounting input:radio').each(function(){
  var curr_selected_radion = $(this).attr('id');
  if(prev_selected_options[0].selected_accounting == curr_selected_radion){
      $(this).prop('checked', true)
  }
 })
 
 }
 setTimeout(function(){
  ready_sidebar();    
 },1000);
 }
 
 // ---------- code for auto preselect variant value function code end here 
 
 $(document).on('click','.js-go-to-cart',function(){ 
  product_selector();
 let quantity_range = $('.sidebar-kinder').val(); 
 let selected_meals_dishes =  $('#js-meals-select li.active').text();
  $('.selected-portion').html($('.sidebar-kinder').val());
  $('.selected-portion-quote').html($('.sidebar-kinder').val());
  $('.selected-meals').html($('#js-meals-select li.active').text());
  $('.selected-mealPreference').html($('input[name="mealPreference"]:checked').attr('data-preference-value'));
  $('.selected-addPrefernce').html($('input[name="addPrefernce"]:checked').attr('data-addi-preference-value')); 
  $('.selected-prefrence').html($('input[name="orderPreference"]:checked').next('label').text());
  $('.selected-device-price').html($('input[name="devices"]:checked').attr('data-pro-price'));
  $('.selected-prefrence-price').html($('input[name="orderPreference"]:checked').attr('data-plan-price'));
  
 
  $('.send-email-quantity-field').val($('.sidebar-kinder').val());
  $('.send-email-weekly-dishes-field').val($('#js-meals-select li.active').text());
  $('.send-email-preference-dishes-field').val($('input[name="mealPreference"]:checked').attr('data-preference-value'));
  $('.send-email-additional-preference-field').val($('input[name="addPrefernce"]:checked').attr('data-addi-preference-value'));
  $('.send-email-order-variant-field').val($('input[name="orderPreference"]:checked').attr('id'));
  $('.send-email-device-field').val($('input[name="devices"]:checked').attr('data-device-attr'));
  $('.send-email-meals-accounting').val($('input[name="meals-accounting"]:checked').attr('data-meal-accounting'));

  var get_abo_device_handle = $('input[name="devices"]:checked').attr('data-device-handle-abo');  
  var get_flex_device_handle = $('input[name="devices"]:checked').attr('data-device-handle-flex');
 
     if ( $('#withDevice').is(':checked')) {
      let aspprice = $('input[name="devices"]:checked').attr('data-pro-price');
      $('.selected-device-price-new').html(aspprice.toString().replace('.', ','));
      $('.extra-device-selected').show();
      $('.sf1-device-price').show();
      $('.sf2-device-price').show();
     }else{
       $('.extra-device-selected').hide();
       $('.sf1-device-price').hide();
       $('.sf2-device-price').hide();
     }
     

     if( $('#ABO').is(':checked') && $('#withDevice').is(':checked')){                     
        if(quantity_range >= 4 && quantity_range <= 10){
          $('input[name="devices"]:checked').attr('data-pro-id', 44123186954508); 
        }else if(quantity_range >= 11 && quantity_range <= 20){
          $('input[name="devices"]:checked').attr('data-pro-id', 44123186987276); 
        }else if(quantity_range >= 21 && quantity_range <= 50){
          $('input[name="devices"]:checked').attr('data-pro-id', 44123187052812); 
        }   
        jQuery.getJSON('/products/' + get_abo_device_handle + '.js', function(data22) {                
        var device_selling_id = $(data22.selling_plan_groups[0].selling_plans[0].id);           
        $('input[name="devices"]:checked').attr('data-sell_id', device_selling_id[0]); 
        }) 
    }
    if( $('#FLEX').is(':checked') && $('#withDevice').is(':checked')){
        if(quantity_range >= 4 && quantity_range <= 10){
          $('input[name="devices"]:checked').attr('data-pro-id', 44123183874316);
        }else if(quantity_range >= 11 && quantity_range <= 20){
          $('input[name="devices"]:checked').attr('data-pro-id', 44123183907084);
        }else if(quantity_range >= 21 && quantity_range <= 50){ 
          $('input[name="devices"]:checked').attr('data-pro-id', 44123183939852);
        } 
        jQuery.getJSON('/products/' + get_flex_device_handle + '.js', function(data22) {                
        var device_selling_id = $(data22.selling_plan_groups[0].selling_plans[0].id);                 
        $('input[name="devices"]:checked').attr('data-sell_id', device_selling_id[0]); 
        })
    }
    
 // console.log(quantity_range)
 // console.log(selected_meals_dishes);
 
//  let shipping_cost_abo_1 = "9,90"
//  let shipping_cost_abo_2 = "12,90"
//  let shipping_cost_abo_3 = "15,90"
//  let shipping_cost_abo_4 = "18,90"
 
//  let shipping_cost_flex_1 = "9,90"
//  let shipping_cost_flex_2 = "12,90"
//  let shipping_cost_flex_3 = "15,90"
//  let shipping_cost_flex_4 = "18,90"
 
//  let shipping_cost_onetime_1 = "9,90"
//  let shipping_cost_onetime_2 = "12,90"
//  let shipping_cost_onetime_3 = "15,90"
//  let shipping_cost_onetime_4 = "18,90"
 

let shipping_cost_abo_1 = "9,90"
let shipping_cost_abo_2 = "16,73"
let shipping_cost_abo_3 = "23,27"
let shipping_cost_abo_4 = "29,90"
let shipping_cost_abo_5 = "36,30"


let shipping_cost_flex_1 = "9,90"
let shipping_cost_flex_2 = "16,73"
let shipping_cost_flex_3 = "23,27"
let shipping_cost_flex_4 = "29,90"
let shipping_cost_flex_5 = "36,30"


let shipping_cost_onetime_1 = "9,90"
let shipping_cost_onetime_2 = "16,73"
let shipping_cost_onetime_3 = "23,27"
let shipping_cost_onetime_4 = "29,90"
let shipping_cost_onetime_5 = "36,30"

 
//  console.log(shipping_cost_abo_1);
 if( $('#ABO').is(':checked')){
  if((quantity_range >= 4 && quantity_range <= 15) && (selected_meals_dishes == 3))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_1)
  }
else if((quantity_range >= 16 && quantity_range <= 35) && (selected_meals_dishes == 3))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_2)
  } 
else if((quantity_range >= 36 && quantity_range <= 50) && (selected_meals_dishes == 3))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_3)
  } 
else if((quantity_range >= 4 && quantity_range <= 10) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_1)
  }
else if((quantity_range >= 11 && quantity_range <= 25) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_2)
  }
else if((quantity_range >= 26 && quantity_range <= 35) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_3)
  }
else if((quantity_range >= 36 && quantity_range <= 50) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_4)
  } 
else if((quantity_range >= 4 && quantity_range <= 10) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_1)
  }
else if((quantity_range >= 11 && quantity_range <= 20) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_2)
  }
else if((quantity_range >= 21 && quantity_range <= 30) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_3)
  }
else if((quantity_range >= 31 && quantity_range <= 40) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_4)
  }
else if((quantity_range >= 41 && quantity_range <= 50) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_abo_5)
  }
 
     $('.abo_order_summery').show();
     $('.flex_order_summery').hide();
     $('.onetime_order_summery').hide();
 }
 
 
 if( $('#FLEX').is(':checked')){
  if((quantity_range >= 4 && quantity_range <= 15) && (selected_meals_dishes == 3))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_1)
  }
else if((quantity_range >= 16 && quantity_range <= 35) && (selected_meals_dishes == 3))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_2)
  } 
else if((quantity_range >= 36 && quantity_range <= 50) && (selected_meals_dishes == 3))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_3)
  } 
else if((quantity_range >= 4 && quantity_range <= 10) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_1)
  }
else if((quantity_range >= 11 && quantity_range <= 25) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_2)
  }
else if((quantity_range >= 26 && quantity_range <= 35) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_3)
  } 
else if((quantity_range >= 36 && quantity_range <= 50) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_4)
  }
else if((quantity_range >= 4 && quantity_range <= 10) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_1)
  }
else if((quantity_range >= 11 && quantity_range <= 20) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_2)
  }
else if((quantity_range >= 21 && quantity_range <= 30) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_3)
  }
else if((quantity_range >= 31 && quantity_range <= 40) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_4)
  }
else if((quantity_range >= 41 && quantity_range <= 50) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_flex_5)
  }
 
     $('.abo_order_summery').hide();
     $('.flex_order_summery').show();
     $('.onetime_order_summery').hide();
 }
 
 
 if( $('#EINMALIG').is(':checked')){
  if((quantity_range >= 4 && quantity_range <= 15) && (selected_meals_dishes == 3))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_1)
  }
else if((quantity_range >= 16 && quantity_range <= 35) && (selected_meals_dishes == 3))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_2)
  } 
else if((quantity_range >= 36 && quantity_range <= 50) && (selected_meals_dishes == 3))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_3)
  } 
else if((quantity_range >= 4 && quantity_range <= 10) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_1)
  }
else if((quantity_range >= 11 && quantity_range <= 25) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_2)
  }
else if((quantity_range >= 26 && quantity_range <= 35) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_3)
  }
else if((quantity_range >= 36 && quantity_range <= 50) && (selected_meals_dishes == 4))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_4)
  } 
else if((quantity_range >= 4 && quantity_range <= 10) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_1)
  }
else if((quantity_range >= 11 && quantity_range <= 20) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_2)
  }
else if((quantity_range >= 21 && quantity_range <= 30) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_3)
}
else if((quantity_range >= 31 && quantity_range <= 40) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_4)
}
else if((quantity_range >= 41 && quantity_range <= 50) && (selected_meals_dishes == 5))
  {
    $('.order-summary__shipping-price .product-ship-price').text(shipping_cost_onetime_5)
  }
 
     $('.abo_order_summery').hide();
     $('.flex_order_summery').hide();
     $('.onetime_order_summery').show();
 }
 
 
 var step_1_total_price = $('.config-box__price').text();
 var delivery_shipping_cost = $('.order-summary__shipping-detail .order-summary__shipping-price .product-ship-price').html();
 // console.log(delivery_shipping_cost);
 var dp1 = step_1_total_price.toString().replace(',', '.');
 // console.log(dp1);
 var dp2 = delivery_shipping_cost.toString().replace(',', '.');
 // console.log('dp2', dp2);
 var price_with_shipping = parseFloat(dp1) + parseFloat(dp2) ;
 // console.log(price_with_shipping);
 var lagopal = Number.parseFloat(price_with_shipping).toFixed(2)
 var gettaxprice = Number.parseFloat(price_with_shipping*7/100).toFixed(2)
 $('.selected-price').html(lagopal.toString().replace('.', ',')) 
 $('.tax-selected-price').html(gettaxprice.toString().replace('.', ','))
 var std_aar = Number.parseFloat(parseFloat(lagopal) + parseFloat(gettaxprice)).toFixed(2);
 //console.log(std_aar)
$('.order-summery-total-price--price').html(std_aar.toString().replace('.', ','))
 
      var local_storage_selected_variant =  $('#product-variant-list :selected').data("attr");
      localStorage.setItem("preselected_variant_list", local_storage_selected_variant);
 
      preselect_jsonObj = [];
      item = {}
      item ["selected_qty"] = $('.sidebar-kinder').val();
      item ["selcted_device"] = $('input[name="devices"]:checked').attr('id');
      item ["selected_order"] = $('input[name="orderPreference"]:checked').attr('id');
      item ["selected_accounting"] = $('input[name="meals-accounting"]:checked').attr('id');

 
      preselect_jsonObj.push(item);
      preselect_jsonString = JSON.stringify(preselect_jsonObj);
      localStorage.setItem("preselected_option", preselect_jsonString);    
       
      
      if( $('#ABO').is(':checked') || $('#FLEX').is(':checked')){
        if ( $('#about-parent-meals-accounting').is(':checked')) {      
            let calculate_meal_accounting = $('input[name="orderPreference"]:checked').attr('data-plan-price');
            calculate_meal_accounting = calculate_meal_accounting.toString().replace(',', '.');
            let number_calculate_meal_accounting = Number.parseFloat(calculate_meal_accounting * $('#js-meals-select li.active').text()).toFixed(2);
            let asper_calculate_meal_accounting = number_calculate_meal_accounting.toString().replace('.', ',');
            $('.selected-device-meals-price-accounting').html(asper_calculate_meal_accounting)
            $('.summery-meals-accounting').show(); 

            let itdeviceperprice = Number.parseFloat($('.selected-device-price').html()/quantity_range).toFixed(2);
            let itshippingperprice = Number.parseFloat(dp2/quantity_range).toFixed(2);
            $('.it-show-device-per-price').text(itdeviceperprice.toString().replace('.', ','));
            $('.it-show-shipping-per-price').text(itshippingperprice.toString().replace('.', ','));


          
            let new_order_summery_total_price = "";
            let aby1 = Number.parseFloat(itdeviceperprice).toFixed(2);
            let aby2 = Number.parseFloat(itshippingperprice).toFixed(2);
          //  console.log('aby1', aby1);
          //  console.log('aby2', aby2);
          //  console.log('number_calculate_meal_accounting', number_calculate_meal_accounting)
            if($('#withDevice').is(':checked')){  
              new_order_summery_total_price = parseFloat(number_calculate_meal_accounting) + parseFloat(aby1) + parseFloat(aby2) + 1.40;   
            }else{
              new_order_summery_total_price = parseFloat(number_calculate_meal_accounting) + parseFloat(aby2) + 1.40; 
            }           
            let jsp = Number.parseFloat(new_order_summery_total_price).toFixed(2);
            var getparenttaxprice = Number.parseFloat(jsp*7/100).toFixed(2)
          //   console.log(jsp)
          //   console.log(getparenttaxprice)
            var std_aar_parent = parseFloat(jsp) + parseFloat(getparenttaxprice);
           // console.log(typeof(std_aar_parent));
            let std_aar_parent_formated = Number.parseFloat(std_aar_parent).toFixed(2);   
            $('.new-order-summery-total-price span').html(jsp.toString().replace('.', ','));
            $('.order-summery-total-price-overtax-price').html(getparenttaxprice.toString().replace('.', ','));
            $('.order-summery-total-tax-price-parent').html(std_aar_parent_formated.toString().replace('.', ','))
            $('.order-summery-admin-price').show();
          //  $('.pro-ship-pri-max').show();
            $('.parent-new-tex-price-summary').show();  
            $('.following-parent-price').show();  
            
        }else{
            $('.summery-meals-accounting').show();     
            $('.order-summery-admin-price').hide();
            $('.pro-ship-pri-max').hide();
            $('.parent-new-tex-price-summary').hide();  
            $('.following-parent-price').hide();  
        }
      }else{
        $('.summery-meals-accounting').hide();     
            $('.order-summery-admin-price').hide();
            $('.pro-ship-pri-max').hide();
            $('.parent-new-tex-price-summary').hide();            
            $('.following-parent-price').hide();  
      }

      // let allFilled = true;
      // $('.postal-code').each(function() {
      //     if ($(this).val() === '') {
      //         allFilled = false;
      //         return false;
      //     }
      // });
      // if(allFilled){
      //   let zipDate = {};
      //   let postalCode = '';
      //   $('.postal-code').each(function() {
      //       postalCode += $(this).val();
      //   });
      //   zipDate['Name_Kindertagespflege'] = $("#js-portion-selected").val();
      //   zipDate['PLZ'] = postalCode;
        
      //   console.log('zipDate ',zipDate); 
      //   $.ajax({
      //     url : "https://checkout.chinuki.de/availability/region/inquiry/",
      //     method : "POST",
      //     dataType : "JSON",
      //     contentType: "application/json; charset=utf-8",
      //     data :JSON.stringify(zipDate),
      //     success : function(data) {
      //       console.log('sended form data ',data)
      //       console.log("Sent email to backend")
      //     },
      //     error : function(data) {
      //       console.log('error');
      //     }  
      //   });
      // }

 }) 
  
 })
 
 
 //  product add to cart code start here
 
 $(document).on('click','.final-cart-btn',function(){ 
  let demoats = [];
  let myVar2 = [];          
  var menu_dishes_selected = "";
  var menu_prefe_selected = "";
  var menu_addi_prefe_selected = "";
  menu_dishes_selected = $("#js-meals-select li.active").attr('data-meals-value');
  menu_prefe_selected = $('input[name="mealPreference"]:checked').attr('data-preference-value');
  menu_addi_prefe_selected = $('input[name="addPrefernce"]:checked').attr('data-addi-preference-value');
  var selected_dish_portion = $('.selected-portion').text();
  var Selected_quantity = $('.selected-portion').text();
  var selected_device_price = $('.selected-device-price').text();
  var selected_prefrence_price = $('.selected-prefrence-price').text(); 
  var selected_subscription_plan = $('input[name="orderPreference"]:checked').attr('id'); 
  var customer_email = $(this).attr('data-customer-email');
 
  var delivery_date_selected = $('.delivery-summary__date-input').val();
 // console.log(delivery_date_selected);

   var onetime_delivery_date = delivery_date_selected.replaceAll('.', '-');
 //  console.log(onetime_delivery_date);
   document.cookie = "onetimedeliverydate="+onetime_delivery_date;

 
  demoats.push(menu_dishes_selected);
  demoats.push(menu_prefe_selected);
  demoats.push(menu_addi_prefe_selected);       
  myVar2 = demoats.join(' / ');  
  var id_to_add_cart = ""; 
  $("#product-variant-list option").each(function(){           
    var d_option = $(this).data('attr');                            
    if( d_option == myVar2 ){
    var demnstar = $(this).attr('value'); 
    $('.final-cart-btn').attr('data-pro-id', demnstar);                    
    }     
 
      id_to_add_cart = $('#product-variant-list').find(`option[data-option1='${menu_dishes_selected}'][data-option2='${menu_prefe_selected}'][data-option3='${menu_addi_prefe_selected}']`).val();                               
  })                       
 
  var pro_id = $(this).attr('data-pro-id');
  var selling_plan_id = $('input[name="orderPreference"]:checked').attr('data-sell_id');    
  var device_pro_id = $('input[name="devices"]:checked').attr('data-pro-id');  
  var device_selling_plan_id = $('input[name="devices"]:checked').attr('data-sell_id');
//  console.log('device selling plan = '+device_selling_plan_id);  
  
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() {  
      //  console.log('cart clear'); 
        setTimeout(function(){
         product_add_cart();   
        },500);          
      }
    });
 
 function product_add_cart(){
 
 
 if ( $('#noDevice').is(':checked')) {  
 
  if ( $('#EINMALIG').is(':checked')) {  
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
    quantity: Selected_quantity,
    id: pro_id,
    properties: { 
      'order_type':'one_time',
      'delivery_date':delivery_date_selected
    }
    },
    dataType: 'json', 
    success: function (data) {     
      $('#js-slider-config').removeClass('is-active');
      $('html').removeClass('is-slider-active');
      $('.slider-bg-overlay').removeClass('is-active');
      // $(".slider__body--popup").addClass('hidden-popup');
         document.location.href = '/checkout';
       //  console.log('one time product added');
    },
    error: function(){
      console.log('product not added');
    }
    });
  }else{
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
    quantity: Selected_quantity,
    id: pro_id,
    properties: { 
      'device' : "without device",
      'portion' : selected_dish_portion,
      'subscription plan Price': selected_prefrence_price,
      'subscription plan':selected_subscription_plan,
      'customer email':customer_email,
      'delivery_date':delivery_date_selected
    },
      selling_plan: selling_plan_id  
    },
    dataType: 'json', 
    success: function (data) { 
      //  console.log(data);
    $('#js-slider-config').removeClass('is-active');
      $('html').removeClass('is-slider-active');
    $('.slider-bg-overlay').removeClass('is-active'); 
    jQuery.getJSON('/cart.js', function(cartdata) {  
      var demostic = btoa(JSON.stringify(cartdata))
      //  console.log(cartdata);
      // console.log('abo or flex product added');

      if($('#about-parent-meals-accounting').is(':checked')){
        document.location.href = 'https://checkout.chinuki.de/daycare/register/?token='+demostic+''; 
      }else{
        document.location.href = 'https://checkout.chinuki.de/cart/?token='+demostic+''; 
      }        
  } );
    },
    error: function(){
      // console.log('product not added');
      console.error('Error:', error);
    }
    });
  }
 }else{
        let itemData = {
         items: []
       };
       itemData.items.push({
        quantity: 1,
        id: device_pro_id,
        properties: {          
         'portion' : selected_dish_portion,
         'device Price': selected_device_price,
         'subscription plan Price': selected_prefrence_price,
         'subscription plan':selected_subscription_plan,
         'customer email':customer_email,
         'delivery_date':delivery_date_selected
        },
        selling_plan: device_selling_plan_id
      });
       itemData.items.push({
        quantity: Selected_quantity,
        id: pro_id,
        properties: { 
         'device' : "with device",
         'device Price': selected_device_price,
         'portion' : selected_dish_portion,            
         'subscription plan Price': selected_prefrence_price,
         'subscription plan':selected_subscription_plan,
         'customer email':customer_email,
         'delivery_date':delivery_date_selected
        },
        selling_plan: selling_plan_id
      });
 
  fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(itemData)
        })
    .then(response => {                  
    $('#js-slider-config').removeClass('is-active');
    $('html').removeClass('is-slider-active');
    $('.slider-bg-overlay').removeClass('is-active'); 
    $(".slider__body--popup").addClass('hidden-popup');

    jQuery.getJSON('/cart.js', function(cartdata) {
      var demostic = btoa(JSON.stringify(cartdata))  
      //  console.log(cartdata);
      // console.log('with device product added to cart');

      if($('#about-parent-meals-accounting').is(':checked')){
        document.location.href = 'https://checkout.chinuki.de/daycare/register/?token='+demostic+''; 
      }else{
        document.location.href = 'https://checkout.chinuki.de/cart/?token='+demostic+''; 
      }    
         
    });
    })
  .catch((error) => {
    console.error('Error:', error);
    // console.log('product not added to cart');
  }); 
         
 }  
 }  
 }) 
 
 // sidebar configuration code end here
 
 
 
 $('.kids-popup-btn').on('click', function(event){
  event.preventDefault();
  $('.step-six-wrap').removeClass('is-active-show');


  // Get the selected portion quantity and convert it to an integer
  // var pre_selected_child_quantity = parseInt($('#js-portion-select li.active').attr('data-quantity'), 10);
  // console.log('Selected Quantity:', pre_selected_child_quantity);


  var above30ValueAttr = $(".form__children-title input").attr('data-above30-value');
  // console.log('above30ValueAttr=', above30ValueAttr);
  
  // Split the string by commas and convert to an array of numbers
  var above30Values = above30ValueAttr.split(',').map(Number);
  
  // Log the array to ensure correct parsing
  // console.log('above30Values=', above30Values);
  
  // Check the under30Value
  var under30Value = parseInt($('.form__children-title input').val(), 10); // Ensure under30Value is a number
  // console.log('under30Value=', under30Value);
  var minChilderQunatiy = $(".form__children-title input").attr('min-childern');
  var maxChilderQunatiy = $(".form__children-title input").attr('max-childern');
  
  // Show or hide based on the selected quantity
  if (under30Value < minChilderQunatiy || under30Value > maxChilderQunatiy){
      // console.log('Condition met, showing configurator30plus-main');
      $('.last-submit-button').removeClass('final-cart-btn');
      $('.last-submit-button').addClass('inquiry-form-submit-btn');
      $('.configurator30plus-main').css('display', 'block'); // Force display block
      // $('.configurator30plus-main').css('display', 'block'); // Force display block
      $('.config-bottom-under-30').hide();
      $('.order-summary').hide();
      $('.delivery-summary').hide();
      $('.config-bottom-above-30').show();
      $('.step-four-wrap .slider__step').addClass('is-active');
      $('.step-six-wrap').css('display', 'none');
      $('.step-six-wrap .slider__step').removeClass('is-active');
  } else {
      // console.log('Condition not met, hiding configurator30plus-main');
      $('.last-submit-button').addClass('final-cart-btn');
      $('.configurator30plus-main').css('display', 'none'); // Force hide
      $('.last-submit-button').removeClass('inquiry-form-submit-btn');
      $('.order-summary').show();
      $('.delivery-summary').show();
      $('.config-bottom-under-30').show();
      $('.config-bottom-above-30').hide();
      $('.step-four-wrap .slider__step').removeClass('is-active');
      $('.step-six-wrap').css('display', 'block');
      $('.step-six-wrap .slider__step').addClass('is-active');
  }
});

// add this function in config js liq - for modal opening
$('.js-delivery-info').click(function () {
    new Modal({
        el: document.getElementById('js-delivery-summary'),
    }).show();
});
$('#agreecondition_one').change(function () {
    this.checked
        ? $('.last-submit-button').prop('disabled', !1)
        : $('.last-submit-button').prop('disabled', !0);
});
//this both allows the scrolling the html body
$('.slider-bg-overlay').click(function () {
    $(html).removeClass('js equalizer-active is-slider-active');
});
$('.js-close-config').click(function () {
    $(html).removeClass('js equalizer-active is-slider-active');
});

$('#js-close-config').click(function() {
    $('.config-box--kids input').val("");
    $(".bottom-header").hide();
    $('#error-message').text('').hide();
    $('.slider-bg-overlay').removeClass('is-active');
    $('.js-cart-step').removeClass('is-active');
    $('.step-six-wrap').removeClass('is-active-show');
    $('.step-four-wrap .slider__step').removeClass('is-active');
    $(".slider__body").scrollTop(0);
    $('.send-quote-step').removeClass('is-active');
    $('.trial-box-step').removeClass('is-active');
});




//  ----------------------- code for trial order place start -----------------------

$('.trial-box-btn').click(function(){
  trial_order_sidebar();
  trial_order();
})

const params = new URLSearchParams(window.location.search);
const urlParams = params.get('tab');

  if(urlParams == 'trialOrder'){
      trial_order_sidebar();
      trial_order();
      $('html').addClass('is-slider-active');
      $('.trial-box-step').addClass('is-active');
      $('#js-slider-config').addClass('is-active');  
  }
  
$(document).on('change', 'input[name=orderPreferenceTrial]:radio', function() {
    trial_order();
})

function trial_order() {

  var subscription_price = $('input[name="orderPreferenceTrial"]:checked').attr('data-plan-price');
  var subscription_price_amount = subscription_price.toString().replace(',', '.'); 
  var subscription_plan = $('input[name="orderPreferenceTrial"]:checked').attr('title'); 
  var trial_qualtity = $('.producttotalqtytrial').html(); 
  var subscription_total = (trial_qualtity * subscription_price_amount);

  $('.selected-prefrence-trial').html(subscription_plan);
  $('.selected-prefrence-price-trial').html(subscription_price);
  $('.multiplied-price-trial').html(subscription_total.toString().replace('.', ','));
  $('.trial-week-discount').html(subscription_total.toString().replace('.', ','));
  
}

$(document).on('change', 'input[name=mealPreferenceTrial]:radio', function() {
    trial_order_sidebar();
})

$(document).on('click','.trial-order-submit',function(){ 

  let trialbox = [];
  let product_vairant = [];    
  var menu_prefe_selected = "";
  var Selected_quantity = "5";

  menu_prefe_selected = $('input[name="mealPreferenceTrial"]:checked').attr('data-preference-value');
  var order_preference = $('input[name="orderPreferenceTrial"]:checked').attr('title');
  var delivery_date_selected = $('#date-trial').val();
  var onetime_delivery_date = delivery_date_selected.replaceAll('.', '-');
  document.cookie = "onetimedeliverydate="+onetime_delivery_date;

  trialbox.push(menu_prefe_selected);
  trialbox.push(Selected_quantity);
  //product_vairant = trialbox.join(' / ');  
  product_vairant = menu_prefe_selected;

  $("#trial-product-variant-list option").each(function(){   
    
    var d_option = $(this).data('attr');
    if( d_option == product_vairant ){
      var demnstar = $(this).attr('value'); 
      $('.trial-order-submit').attr('data-pro-id', demnstar);                    
    }     
  })

  var pro_id = $(this).attr('data-pro-id');
  $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() {  
      //  console.log('cart clear'); 
        setTimeout(function(){
          trial_box_product_add_cart();   
        },500);          
      }
    });


  function trial_box_product_add_cart()
  {
    console.log(Selected_quantity);
    console.log(pro_id);
    console.log(delivery_date_selected);
    console.log(menu_prefe_selected);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
      quantity: Selected_quantity,
      id: pro_id,
      properties: { 
        'order_type':'trial_order',
        'delivery_date':delivery_date_selected,
        'order_preference':order_preference
      }
      },
      dataType: 'json', 
      success: function (data) {     
        $('#js-slider-config').removeClass('is-active');
        $('html').removeClass('is-slider-active');
        $('.slider-bg-overlay').removeClass('is-active');
            document.location.href = '/checkout';
      },
      error: function(){
        console.log('product not added');
      }
    });
  }
})

function trial_order_sidebar(){  

  var get_pro_handle = $('input[name="mealPreferenceTrial"]:checked').attr('data-product-handle');

  console.log('***********************888');
  console.log(get_pro_handle);

  jQuery.getJSON('/products/' + get_pro_handle + '.js', function(data2) {  

    console.log('***********************9999');
    console.log(data2);

    //  ----------- Product variant selector code --------------
 
      var variant_structure = [];
      for (let i = 0; i < data2.variants.length; i++){                        
        var new_pro_title = data2.variants[i].title;         
        var new_pro_id =data2.variants[i].id;

        if(data2.variants[i].featured_image != null ){          
          var new_pro_feature_img = data2.variants[i].featured_image.src;
        }else{
          var new_pro_feature_img = data2.featured_image;
        }  

        var new_pro_price=data2.variants[i].price; 
        var pri_update =  parseFloat(new_pro_price / 100);  
        variant_structure += '<option data-attr="'+new_pro_title+'" value='+data2.variants[i].id+' data-option1="'+data2.variants[i].option1+'" data-option2="'+data2.variants[i].option2+'" data-option3="'+data2.variants[i].option3+'" data-price="'+pri_update+'" data-var-img="'+new_pro_feature_img+'">'+new_pro_title+'</option>';              
        $("#trial-product-variant-list").html(variant_structure);          
      }
  })
}

//  ----------------------- code for trial order place end -----------------------



//  ----------------------- code for calendy popup start -----------------------

const calendlyButton = document.querySelector('.js-open-calendly-popup');
const calendlyPopup = document.querySelector('.js-calendly-popup');
const calendlyPopupCloseBtn = document.querySelector('.js-calendly-popup-close-btn');

if(calendlyButton) {
  calendlyButton.addEventListener('click',function(){
    if(calendlyPopup.classList.contains('popup-is-open')) {
      calendlyPopup.classList.remove('popup-is-open');
      calendlyPopup.style.display = "none";
    }
    else {
      calendlyPopup.classList.add('popup-is-open');
      calendlyPopup.style.display = "block";
    }
    if(header.classList.contains('nav-is-open')) {
        html.classList.remove('nav-is-open');
        header.classList.remove('nav-is-open');
    }
    if(document.querySelector('#js-slider-config')) { 
      if(document.querySelector('#js-slider-config').classList.contains('is-active')) {
        document.querySelector('#js-slider-config').classList.remove('is-active');
        document.querySelector('.js-cart-step').classList.remove('is-active');
        document.querySelectorAll('.slider-bg-overlay').forEach(element => {
          element.classList.remove('is-active');
        });
        html.classList.remove('is-slider-active');
      }
    }
    $(html).addClass('is-slider-active');
  });
}

if(calendlyPopupCloseBtn) {
  calendlyPopupCloseBtn.addEventListener('click',function(){
    if(calendlyPopup.classList.contains('popup-is-open')) {
      calendlyPopup.classList.remove('popup-is-open');
      calendlyPopup.style.display = "none";
    }
    $(html).removeClass('is-slider-active');
  });
}

$(".js-calendly-popup").on("click", function() {
    $(this).hide();
    $(html).removeClass("is-slider-active");
    $(this).removeClass("popup-is-open");
})

//  ----------------------- code for calendy popup end -----------------------